export const ZhChtChatroomStrings = {
  SETTINGS: "設定",
  PHOTO: "相片",
  VIDEO: "影片",
  DOCUMENT: "文件",
  MESSAGE_STAR: '星號信息',
  
  EXPORT_CHAT: {
    TITLE: "導出聊天訊息",
    CHAT: "聊天室: ",
    TIME: "時間: ",
    CHAT_INFO: "聊天室: ",
    EXPORT_TIME_PERIOD: "時間範圍",
    RANGE_SELECT_MSG: "請選擇時間範圍，在此範圍內的訊息將被導出。",
    NO_TIME_PERIOD_ERROR_MSG: "請選擇時間範圍",
    CONFIRM_MSG: "確定導出由 {{FROM}} 至 {{TO}} 的訊息？",
    IN_PROGRESS_MSG: "聊天訊息導出中，你可以在右上角的通知中心查看進度，你將在檔案準備完成後收到通知。",
    EXPORT_DONE_DOWNLOAD: "完成，按此下載。",
    EXPORT_READY_MSG: "聊天訊息檔案已準備完成，你可以在通知中心下載檔案。",
    EXPORT_WITH_WATERMARK: {
      TITLE: "在附件上添加水印? ",
      TIP: "(如選擇添加水印，只有相片會被導出。)"
    }
  },

  SEND: "傳送",
  TEXTAREA_PLACEHOLDER: {
    IE: "輸入訊息 / 拖曳文件",
    OTHERS: "輸入訊息 / 拖曳文件 / 貼上圖片",
    TEXT_ONLY: "輸入訊息",
    DROP_FILE_TIPS: "拖曳文件"
  },
  MESSAGE_OPTION: {
    UPLOAD: "上載",
    LOCATION: "地點",
    ATTACH: "附件",
    EXIT_EDIT: "退出編輯模式",
    IMPORTANT: "重要",
    SMS: "短訊",
    SELECT_FROM_DOCUMENT_SHARING: "從檔案分享中選擇",
    POLL: "投票"
  },

  WHISPER: "私訊",
  NAME_WHISPER_LABEL: "{{USER}} (私訊)",

  READ: "已閱",
  READ_GROUP: "已閱 {{NUM}}",

  EDITED: "已編輯",

  NEW_MESSAGE: {
    ONE: "新訊息 ({{NUM}})",
    MULTIPLE: "新訊息 ({{NUM}})"
  },
  UNREAD_MESSAGE_HEADER: "新訊息",

  ONLINE: "在線",
  LAST_SEEN: "最後在線時間: ",
  NOT_EXIST: "聊天室不存在",
  
  JOIN_CHAT: "{{ACTOR}} 把 {{USERS}} 加入群組",
  LEAVE_GROUP: "{{USERS}} 已離開群組",
  ADMIN_CHANGE: {
    ONE: "{{USER}} 已成為群組管理員",
    MULTIPLE: "{{USERS}} 已成為群組管理員"
  },
  ADMIN_REMOVED: {
    ONE: "{{USER}} 已不再是群組管理員",
    MULTIPLE: "{{USERS}} 已不再是群組管理員"
  },
  MESSAGE_RECALLED: {
    ME: "你已收回一則訊息",
    OTHERS: "{{USER}} 已收回一則訊息"
  },

  CLASSIFICATION_LEVEL: {
    AUTH_TITLE: "您正在進入一個機密聊天室，訊息將在離開此聊天室時刪除。請再次進行驗證以接受並進入聊天室。",
    DESC: "訊息分級: ",
    LEVEL0: "一般",
    LEVEL1: "內部", // origin: 限閱
    LEVEL2: "限閱" // origin: 機密
  },

  ENCRYPTED_MESSAGE: {
    AUTH_TITLE: "查看安全訊息前請先進行驗證",
    MESSAGE_PREVIEW: "安全訊息，點擊查看",
    STARRED_MESSAGE_PREVIEW: "安全訊息，請在聊天室內點擊查看"
  },

  CRITICAL_MESSAGE: {
    SEND_WARNING: "重要通知：你即將向本組所有用戶發送重要消息。此消息將伴隨強制性警報和通知發送。請確認是否繼續發送此關鍵消息。",
    EXPORT: {
      TITLE: "導出重要訊息",
      EXPORT_FINISH_TIME: "導出時間: ",
      EXPORT_READY_MSG: "重要訊息檔案已準備完成，你可以在通知中心下載檔案。",
      IN_PROGRESS_MSG: "重要訊息導出中，你可以在右上角的通知中心查看進度，你將在檔案準備完成後收到通知。",
    }
  },

  OUT_OF_OFFICE: {
    UNTIL: "不在辦公室直到 ",
    COUNT: {
      ONE: "{{NUM}} 人不在辦公室",
      MULTIPLE: "{{NUM}} 人不在辦公室"
    }
  },

  REPLY: {
    YOU: "您",
    IMAGE: "相片",
    VIDEO: "影片",
    AUDIO: "語音訊息",
    DOCUMENT: "文件",
    LOCATION: "位置",
    STICKER: "貼圖"
  },

  GROUP_INFO_ITEM: {
    ADMIN: "群組管理員",
    OUT_OF_OFFICE: "不在辦公室"
  },

  MESSAGE_OPTIONS: {
    INFO: "訊息詳情",
    ACKNOWLEDGEMENT_INFO: '訊息回報詳情',
    FORWARD: "轉發",
    // SELECT: "選擇訊息",
    SELECT: "轉發",
    DOWNLOAD: "下載",
    RECALL: "收回訊息",
    REPLY: "回覆",
    EDIT: "編輯",
    REPORT: "回報訊息",
    STAR: '標上星號',
    UNSTAR: '移除星號',
    PIN: '置頂訊息',
    UNPIN: '取消置頂',
    COPY: '複製',
    EMOJI: '發送表情',
    DELETE: "刪除",
    EXPORT_CRITICAL_MSG: "導出訊息",
  },

  EMOJI_INFO: {
    TITLE: "表情詳情",
    PREVIEW_TITLE: "所有 {{emoji_count}} 個表情"
  },

  MESSAGE_INFO: {
    TITLE: "訊息詳情",
    READ_HEADER: "已讀取",
    DELIVERY_HEADER: "已傳送",
    UNREAD_HEADER: "未讀取",
    ACKNOWLEDGED_HEADER: '已確認',
    SMS_HEADER: "短訊狀態"
  },

  RECALL: {
    SUCCESS: "訊息收回成功",
    FAIL: "訊息收回失敗"
  },

  FORWARD: {
    CONFIRM_MSG: "確定轉發訊息到 {{chat}}?",
    SUCCESS_MSG: "訊息已轉發"
  },

  DELETE: {
    CONFIRM_MSG: "是否刪除此訊息?"
  },

  ACK: {
    ACKED: "已確認",
    ACK: "確認"
  },

  FALLBACK_STATUS: {
    PENDING: '等候傳送',
    SENT: '已傳送',
    ERROR: '發生錯誤'
  },

  POLL: {
    CREATE_TITLE: "建立投票",
    QUESTION_LABEL: "問題",
    TITLE_PLACEHOLDER: "輸入問題",
    OPTIONS_LABEL: "選項",
    OPTION_PLACEHOLDER: "新增",
    ADD_OPTION: "新增選項",
    ALLOW_MULTIPLE_CHOICE: "允許選擇多項",
    DISPLAY_RESULT_LABEL: "顯示結果",
    DISPLAY_RESULT_OPTIONS: {
      ALWAYS: "一律顯示",
      NEVER: "不顯示",
      AFTER_VOTE_END: "結束後顯示",
      AFTER_USER_VOTE: "投票後顯示"
    },
    END_TIME_TOGGLE: "設定結束時間",
    END_TIME_HINT_NO_END_TIME: "結束此投票後將顯示結果",
    CREATE_BUTTON: "傳送",
    SELECT_ONE_HINT: "選擇一項",
    MULTIPLE_CHOICE_HINT: "選擇一項或多項",
    VOTES_COUNT: {
      ONE: "{{COUNT}} 票",
      MULTIPLE: "{{COUNT}} 票"
    },
    ENDED: "投票已結束",
    END_BUTTON: "結束投票",
    END_CONFIRM: "結束後將無法再投票，確定要立即結束嗎?",
    ALREADY_ENDED: "此投票已經結束。",
    VIEW_VOTES: "查看投票",
    DETAIL_TITLE: "投票結果",
    VOTER_YOU: "你",
    VOTED_TODAY: "今天",
    VOTED_YESTERDAY: "昨天",
    NO_VOTES_YET: "暫無投票",
    ERROR: {
      TITLE_REQUIRED: "請輸入問題及至少兩個選項",
      TITLE_TOO_LONG: "問題長度不可超過255個字符",
      OPTIONS_MIN: "請輸入問題及至少兩個選項",
      OPTIONS_MAX: "投票最多可設置12個選項",
      OPTION_EMPTY: "請輸入問題及至少兩個選項",
      OPTION_TOO_LONG: "每個選項長度不可超過100個字符",
      END_TIME_INVALID: "結束時間無效",
      END_TIME_PAST: "結束時間已過，請選擇較後的時間。"
    }
  },

  PINNED_MESSAGE: {
    LIST_TITLE: "置頂訊息",
    PINNED_BY: "由 {{USER}} 置頂",
    EMPTY: "暫無置頂訊息",
    UNPIN_CONFIRM_MSG: "是否取消置頂此訊息？"
  }

}
